import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.css'
import '../public/css/reset.css'
import '../public/css/color.css'
import '../public/css/custom_global.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import lang from 'element-ui/lib/locale/lang/vi'
import locale from 'element-ui/lib/locale'
import '../public/css/color.css'
// Import Leaflet CSS for map functionality
import 'leaflet/dist/leaflet.css'
// Import enter-search directive
import enterSearch from './directives/enterSearch'

locale.use(lang)
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(ElementUI)

// Register global directive for Enter key search
Vue.directive('enter-search', enterSearch)

// console.log = function () {}

new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount('#app')
